// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountDeletionController from "./account_deletion_controller"
application.register("account-deletion", AccountDeletionController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatPanelController from "./chat_panel_controller"
application.register("chat-panel", ChatPanelController)

import ChatSidebarController from "./chat_sidebar_controller"
application.register("chat-sidebar", ChatSidebarController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GoalEditController from "./goal_edit_controller"
application.register("goal-edit", GoalEditController)

import GoalsFormController from "./goals_form_controller"
application.register("goals-form", GoalsFormController)

import GoalsPanelController from "./goals_panel_controller"
application.register("goals-panel", GoalsPanelController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MemoryController from "./memory_controller"
application.register("memory", MemoryController)

import MessageActionsController from "./message_actions_controller"
application.register("message-actions", MessageActionsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)


import VoiceStreamingController from "./voice_streaming_controller"
application.register("voice-streaming", VoiceStreamingController)

import LivekitStreamingController from "./livekit_streaming_controller"
application.register("livekit-streaming", LivekitStreamingController)

import LivekitVoiceController from "./livekit_voice_controller"
application.register("livekit-voice", LivekitVoiceController)

import NudgeSettingsController from "./nudge_settings_controller"
application.register("nudge-settings", NudgeSettingsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
